import $ from '../../../../../src/Resources/core/jsx/utils/jquery-global';
import 'bootstrap/js/transition';
import 'bootstrap/js/collapse';

$(() => {
  initKeyboard();
});

$(window).on('pageshow popstate', function () {
  showAll();

  const params = new URLSearchParams(window.location.search);
  const letter = params.get('letter');
  const search = params.get('search');
  const types = params.get('glossaryType');

  const fragment = window.location.hash;
  if (fragment) {
    // close open expanded accordions
    $('.show').each(function () {
      $(this).removeClass('show');
    });

    const $targetItem = $(fragment);
    if ($targetItem.length > 0) {
      const targetBody = $targetItem.find('.accordion-collapse');
      targetBody.addClass('show');
      $targetItem[0].scrollIntoView({ behavior: 'smooth' });
    }
  }

  initKeyboard();

  if (search !== null) {
    $('#mh-glossary-search-field').val(search);
    synchronizePaginationButtons('search', search);
  } else {
    $('#mh-glossary-search-field').val('');
  }

  // Select letter matching to query
  if (letter !== null) {
    const $element = $('.key.letter[data-letter="' + letter + '"]');
    selectKey($element);
    synchronizePaginationButtons('letter', letter);
  }

  // Set filters in sidebar
  if (types !== null) {
    const activeTypes = types.split(',');
    if (activeTypes.length !== TOTAL_NUMBER_OF_GLOSSARY_TYPES) {
      $('#sidebar-filter-all-cb').prop('checked', false);
      $('.sidebar-filter-cb').each(function () {
        const type = $(this).data('glossary-type');
        $(this).prop('checked', activeTypes.includes(type));
      });
      synchronizePaginationButtons('glossaryType', types);
    }
  }

  // Handle button clicks for letters and numbers
  $('.key').click(function () {
    if ($(this).hasClass('clicked')) {
      deselectKey($(this));
      window.location.href = '/resources/glossary';
      return;
    }

    $('#mh-glossary-search-field').val('');
    deselectKeys();
    const letterOrNumber = $(this).data('letter');
    window.location.href = `/resources/glossary?letter=${letterOrNumber}`;
  });
  // Toggle between letter and number buttons visibility
  $('#toggleNumbers').click(function () {
    $('.letter').toggleClass('hidden');
    $('.number').toggleClass('hidden');
  });

  $('#mh-glossary-search-form').on('submit', function (event) {
    event.preventDefault();
    deselectKeys();
    const searchTerm = $('#mh-glossary-search-field').val();
    console.log(searchTerm);
    window.location.href = `/resources/glossary?search=${searchTerm}`;
  });

  $('.glossary-sidebar-all-filter').on('click', function () {
    var checked = document.getElementById('sidebar-filter-all-cb').checked;
    $('.sidebar-filter-cb').each(function () {
      $(this).prop('checked', checked);
    });
  });

  $('#sidebar-filter-teacher').on('click', function () {
    console.log('filter teacher event');
    toggleAllSelector();
    $('.mh-glossary-type-dharma_teacher').toggleClass('hidden');
    updateUrl();
  });
  $('#sidebar-filter-buddha-aspect').on('click', function () {
    console.log('filter buddha aspect event');
    toggleAllSelector();
    $('.mh-glossary-type-buddha_aspect').toggleClass('hidden');
    updateUrl();
  });
  $('#sidebar-filter-transmission').on('click', function () {
    console.log('filter transmission event');
    toggleAllSelector();
    $('.mh-glossary-type-transmission').toggleClass('hidden');
    updateUrl();
  });
  $('#sidebar-filter-buddhist-term').on('click', function () {
    console.log('filter buddhist term event');
    toggleAllSelector();
    $('.mh-glossary-type-buddhist_term').toggleClass('hidden');
    updateUrl();
  });
  $('#sidebar-filter-location').on('click', function () {
    console.log('filter location event');
    toggleAllSelector();
    $('.mh-glossary-type-location').toggleClass('hidden');
    updateUrl();
  });
});

function toggleAllSelector() {
  let allSelected = true;
  $('.sidebar-filter-cb').each(function () {
    allSelected = allSelected && this.checked;
  });
  $('#sidebar-filter-all-cb').prop('checked', allSelected);
}

function initKeyboard() {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const keyboard = $('#keyboard');

  if (keyboard.data('initialized')) {
    return;
  }

  // Create a toggle button for numbers and add it before the letters
  keyboard.append(`<div class="toggle" id="toggleNumbers">0-9</div>`);

  // Create buttons for each letter
  for (let i = 0; i < alphabet.length; i++) {
    const letter = alphabet[i];
    keyboard.append(
      `<div class="key letter" data-letter="${letter}">${letter}</div>`,
    );
  }

  // Create buttons for each number and hide them initially
  for (let i = 0; i < numbers.length; i++) {
    const number = numbers[i];
    keyboard.append(
      `<div class="key number hidden" data-letter="${number}">${number}</div>`,
    );
  }
  keyboard.data('initialized', true);
}

function synchronizePaginationButtons(param, value) {
  const $previousPageButton = $('#pagination-prev-page-link');
  const previousPageBaseUrl = $previousPageButton.attr('href');
  const $nextPageButton = $('#pagination-next-page-link');
  const nextPageBaseUrl = $nextPageButton.attr('href');
  $previousPageButton.attr('href', `${previousPageBaseUrl}&${param}=${value}`);
  $nextPageButton.attr('href', `${nextPageBaseUrl}&${param}=${value}`);
}

function deselectKey($el) {
  $el.removeClass('clicked');
}

function selectKey($el) {
  $el.addClass('clicked');
}

function deselectKeys() {
  $('.key').each(function () {
    deselectKey($(this));
  });
}

function getActiveTypeFilters() {
  return $('.sidebar-filter-cb')
    .not('#sidebar-filter-all-cb')
    .filter(':checked')
    .map(function () {
      return $(this).data('glossary-type');
    })
    .get();
}

const TOTAL_NUMBER_OF_GLOSSARY_TYPES = 5;

export function buildQueryFromFilters(types) {
  const params = new URLSearchParams(window.location.search);

  if (types.length === 0 || types.length === TOTAL_NUMBER_OF_GLOSSARY_TYPES) {
    params.delete('glossaryType');
  } else {
    params.set('glossaryType', types.join(','));
  }

  return params.toString().replace(/%2C/g, ',');
}

function updateUrl() {
  const typeFilters = getActiveTypeFilters();
  const query = buildQueryFromFilters(typeFilters);
  const newUrl = query
    ? `${window.location.pathname}?${query}`
    : window.location.pathname;

  window.location.href = newUrl;
  // window.history.pushState({}, '', newUrl);
}

function showAll() {
  $('div.mh-accordion-item').each(function () {
    $(this).show();
  });
}
